import { type FilterableProperty, IconName } from '@talos/kyoko';
import { identity } from 'lodash-es';
import { useMemo } from 'react';
import { useMarketAccountGroups } from '../useMarketAccountGroups';

/**
 * This hook creates the filter property definition for Market Accounts properties.
 *
 * @returns Filter Property definition to use for Market Accounts filters
 */
export function useMarketAccountGroupsFilter() {
  const groups = useMarketAccountGroups();

  return useMemo(
    () =>
      ({
        key: 'MarketAccountGroups',
        label: 'Group',
        icon: IconName.UserGroup,
        options: groups,
        getOptionLabel: identity,
      }) as const satisfies FilterableProperty,
    [groups]
  );
}
